<template>
  <div class="events">
    <div class="events-actions">
      <selection
        :id="`events-date`"
        :options="dates"
        :selected="date"
        :placeholder="'Date'"
        :disabled="datesDisabled"
        @option="$emit('filter', { event: $event, type: 'date' })"
      />
        <!-- @option="onFilter($event, 'date')" -->

      <selection
        :id="`events-category`"
        :options="categories"
        :selected="category"
        :placeholder="'Catégorie'"
        @option="$emit('filter', { event: $event, type: 'category' })"
      />
        <!-- @option="onFilter($event, 'category')" -->
    </div>

    <div class="events-list">
        <template
        v-if="events.length > 0"
      >
        <event
          v-for="(event, index) in events"
          :key="`${event.id}-${index}`"
          :event="event"
        />
      </template>

      <p
        v-if="events.length === 0 && !loading"
        class="events-list-noresult"
      >
        Il n'y a pas de résultat pour la recherche effectuée
      </p>
    </div>

    <loader v-if="loading" />
  </div>
</template>

<script>
import Selection from '@/components/components/Selection.vue';
import Event from '@/components/modules/Event.vue';
import Loader from '@/components/components/Loader.vue';

export default {
  components: {
    Loader,
    Selection,
    Event
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    events: {
      type: Array,
      default: () => []
    },
    dates: {
      type: Array,
      default: () => []
    },
    date: {
      type: Object,
      default: () => {}
    },
    categories: {
      type: Array,
      default: () => []
    },
    category: {
      type: Object,
      default: () => {}
    },
    datesDisabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.events {
  &-actions {
    @include margin(24px null null);
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 4;

    .selection {
      width: calc(50% - 10px);
    }
  }

  &-list {
    @include padding(null null 40px);
    width: 100%;

    + .loader {
      padding-top: 0 !important;
      padding-bottom: 40px !important;
    }

    .event {
      @include margin(20px null null);
      width: 100%;
    }

    &-noresult {
      @include margin(32px null null);
      color: $white;
      font-size: rem(22px);
      line-height: (26 / 24);
    }
  }
}
</style>
